module.exports = __webpack_public_path__ + "static/media/img12.d5909411.png";